import React from "react";

/**
 * SVG-based EAKC rainbow title — renders reliably.
 * Avoids CSS background-clip: text bugs in Chromium when combined with
 * filter: drop-shadow / transform: scale / parent containing blocks.
 */
export const RainbowEAKC: React.FC<{
  frame: number;
  fontSize: number;
  fontFamily?: string;
  scale?: number;
  opacity?: number;
  /** unique id for SVG defs to avoid collisions between instances */
  id: string;
  glowColor?: string;
}> = ({
  frame,
  fontSize,
  fontFamily = "Inter, SF Pro Display, system-ui, sans-serif",
  scale = 1,
  opacity = 1,
  id,
  glowColor = "#A855F7",
}) => {
  // Roughly size SVG viewport to fit "EAKC" at the given fontSize.
  const width = Math.round(fontSize * 3.1);
  const height = Math.round(fontSize * 1.15);

  // Animated rainbow rotation — shift stop offsets over time so the
  // gradient appears to sweep horizontally.
  const shift = (frame * 0.004) % 1; // 0..1
  const stops = [
    { o: 0.0, c: "#FF2D95" },
    { o: 0.14, c: "#FF6B35" },
    { o: 0.28, c: "#FFD60A" },
    { o: 0.42, c: "#00FF88" },
    { o: 0.56, c: "#00E5FF" },
    { o: 0.70, c: "#00D4FF" },
    { o: 0.84, c: "#A855F7" },
    { o: 1.0, c: "#FF2D95" },
  ].map((s) => ({ ...s, o: (s.o + shift) % 1 }))
    .sort((a, b) => a.o - b.o);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{
        transform: `scale(${scale})`,
        opacity,
        overflow: "visible",
      }}
    >
      <defs>
        <linearGradient id={`eakc-rainbow-${id}`} x1="0%" y1="0%" x2="100%" y2="0%">
          {stops.map((s, i) => (
            <stop key={i} offset={`${s.o * 100}%`} stopColor={s.c} />
          ))}
        </linearGradient>
        <filter id={`eakc-glow-${id}`} x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation={fontSize / 20} result="blurOut" />
          <feComponentTransfer in="blurOut" result="colored">
            <feFuncA type="linear" slope="1.5" />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode in="colored" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Soft purple underglow */}
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={fontSize}
        fontFamily={fontFamily}
        fontWeight={900}
        letterSpacing={-fontSize / 28}
        fill={glowColor}
        opacity={0.35}
        filter={`url(#eakc-glow-${id})`}
      >
        EAKC
      </text>

      {/* Rainbow gradient text */}
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={fontSize}
        fontFamily={fontFamily}
        fontWeight={900}
        letterSpacing={-fontSize / 28}
        fill={`url(#eakc-rainbow-${id})`}
      >
        EAKC
      </text>
    </svg>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
